module.exports = __webpack_public_path__ + "img/refresh.a27a6113.png";